import { render } from "./UnitsList.vue?vue&type=template&id=7c9ff9f0&scoped=true"
import script from "./UnitsList.vue?vue&type=script&lang=js"
export * from "./UnitsList.vue?vue&type=script&lang=js"

import "./UnitsList.vue?vue&type=style&index=0&id=7c9ff9f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9ff9f0"]])

export default __exports__